<template>
  <div class="content">
    <div class="col-md-8 ml-auto mr-auto">
      <h2 class="text-center">{{ $t('inspection_events.title') }}</h2>
      <p class="text-center">
        {{ $t('inspection_events.description') }}
      </p>
    </div>
    <div class="row mt-5">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title">{{ $t('inspection_events.table') }}</h4>
          <inspection-events-table :per-account="false"/>
        </card>
      </div>
    </div>
  </div
  >
</template>
<script>
import InspectionEventsTable from "@/components/InspectionEvent/InspectionEventsTable";

export default {
  name: 'inspection-events',
  components: {InspectionEventsTable},
};
</script>
